import api, { headers, API_V1 } from "./api";

export const signUp = async (body) => {
  return await api.post(`${API_V1}/auth/signup`, body, { headers });
};

export const signIn = async (body) => {
  return await api.post(`${API_V1}/auth/signin`, body);
};

//
export const googleSignUp = async (body) => {
  return await api.post(`${API_V1}/signup/google`, body);
};
